import { render, staticRenderFns } from "./Deposits.vue?vue&type=template&id=5860706e&lang=pug&"
import script from "./Deposits.vue?vue&type=script&lang=ts&"
export * from "./Deposits.vue?vue&type=script&lang=ts&"
import style0 from "./Deposits.vue?vue&type=style&index=0&id=5860706e&prod&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports